"use client"

import * as React from "react"

import { CreateKind } from "@/features/create-overlay/model/create-kind"

/**
 * Kind -> its form, loaded on first open. A form takes no props: it reads `useCreateOverlayForm()` (form id,
 * phone or desktop, prefill, `complete`) and renders `<CreateOverlayBody>` inside its `<form id={formId}>`.
 * Layout, permission and list page live in `CREATE_KIND_META`; title, subtitle and button label in the
 * `createOverlay.kinds.<kind>` messages.
 */
export const CREATE_OVERLAY_FORMS: Record<CreateKind, React.LazyExoticComponent<React.ComponentType>> = {
  [CreateKind.Member]: React.lazy(() =>
    import("@/features/members/components/create/member-create-form").then((module) => ({ default: module.MemberCreateForm })),
  ),
  [CreateKind.Visitor]: React.lazy(() =>
    import("@/features/members/components/create/visitor-create-form").then((module) => ({ default: module.VisitorCreateForm })),
  ),
  [CreateKind.Minister]: React.lazy(() =>
    import("@/features/church/config/ministers/components/minister-create-form").then((module) => ({
      default: module.MinisterCreateForm,
    })),
  ),
  [CreateKind.Activity]: React.lazy(() =>
    import("@/features/activities/components/create/activity-create-overlay-form").then((module) => ({
      default: module.ActivityCreateOverlayForm,
    })),
  ),
  [CreateKind.Asset]: React.lazy(() =>
    import("@/features/assets/components/create/asset-create-overlay-form").then((module) => ({
      default: module.AssetCreateOverlayForm,
    })),
  ),
  [CreateKind.Offering]: React.lazy(() =>
    import("@/features/finance/components/create/transaction-create-form").then((module) => ({ default: module.OfferingCreateForm })),
  ),
  [CreateKind.Expense]: React.lazy(() =>
    import("@/features/finance/components/create/transaction-create-form").then((module) => ({ default: module.ExpenseCreateForm })),
  ),
  [CreateKind.Transfer]: React.lazy(() =>
    import("@/features/finance/components/create/transfer-create-form").then((module) => ({ default: module.TransferCreateForm })),
  ),
  [CreateKind.TransferRequest]: React.lazy(() =>
    import("@/features/finance/components/create/transfer-request-create-form").then((module) => ({
      default: module.TransferRequestCreateForm,
    })),
  ),
  [CreateKind.Pledge]: React.lazy(() =>
    import("@/features/pledges/components/create/pledge-create-form").then((module) => ({ default: module.PledgeCreateForm })),
  ),
  [CreateKind.Budget]: React.lazy(() =>
    import("@/features/budgeting/components/create/budget-create-form").then((module) => ({ default: module.BudgetCreateForm })),
  ),
}
